import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_SearchConfig_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_SEARCH_ID:         {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB SearchConfig Id',  columnResourceName: 'colwbId',            alignment: HorizAlignment.Left},  domainOptions: {} },
    SEARCH_ID:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'ID',     columnResourceName: 'colId',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SEARCH_NAME:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Name',       columnResourceName: 'colName',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMMENTS:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Description',       columnResourceName: 'colDescription',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}}

};

const SearchConfigSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_SEARCH_ID',
        id_ui: 'SEARCH_ID',
        name:  'SEARCH_NAME'
    },

    searchProviderFields: vUI_SearchConfig_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Search_Config_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const SearchConfigSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "SearchConfigSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'ID', searchProviderFieldId: 'SEARCH_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SEARCH_NAME', renderOptions: {}},
        {profileFilterName: 'Description', searchProviderFieldId: 'COMMENTS', renderOptions: {}}
    ],
    profileDisplayFields: [
        'SEARCH_ID', 'SEARCH_NAME', 'COMMENTS'
    ],

    profileSearchProvider: SearchConfigSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SearchConfigSearch: ISearch = {
    searchName: "Find SearchConfig",
    renderOptions: {ui5ResourceId: "SearchConfigSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SearchConfigSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("SearchBO", "SearchConfig", SearchConfigSearch, "Search Config Search")

export {SearchConfigSearch}